import { useEffect } from 'react';
import {
  paginatedListPath,
  paginationScrollOrigin,
  scrollAfterPageChange,
} from '@/utils/paginationScroll';

const scrollFrom = (control: Element) => {
  const path = paginatedListPath(control);
  // Wait a frame so the page has reacted to the click (loading state, new page number)
  // before the list position is measured.
  requestAnimationFrame(() => {
    const list = path.find((el) => el.isConnected);
    if (list) scrollAfterPageChange(list);
  });
};

/**
 * Every admin list uses Ant Design pagination. After a page change, scroll back to the
 * top so the first row of the new page is on screen. Lists must page with antd's
 * Pagination (Table, ProTable, List or the bare component) to be covered.
 */
const PaginationScrollToTop: React.FC = () => {
  useEffect(() => {
    const onClick = (event: MouseEvent) => {
      const origin = paginationScrollOrigin(event.target);
      if (origin) scrollFrom(origin);
    };

    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key !== 'Enter') return;
      const target = event.target;
      if (!(target instanceof Element)) return;
      // Quick jumper ("go to page N").
      if (target instanceof HTMLInputElement) {
        if (target.value.trim() && target.closest('.ant-pagination'))
          scrollFrom(target);
        return;
      }
      const origin = paginationScrollOrigin(target);
      if (origin) scrollFrom(origin);
    };

    document.addEventListener('click', onClick, true);
    document.addEventListener('keydown', onKeyDown, true);
    return () => {
      document.removeEventListener('click', onClick, true);
      document.removeEventListener('keydown', onKeyDown, true);
    };
  }, []);

  return null;
};

export default PaginationScrollToTop;
